import { useState } from "react";
import { Locale } from "../Languages";
import { makeGraphqlRequest } from "../tracking/makeGraphqlRequest";

export enum homepageLocale {
    de_de = "de_de",
    de_at = "de_at",
    de_ch = "de_ch",
    en_uk = "en_uk",
    pl_pl = "pl_pl"
}
export const mapApiLocale = (locale: Locale) => {
    let apiLocaleMap = {
        "DE-DE": homepageLocale.de_de,
        "DE-AT": homepageLocale.de_at,
        "DE-CH": homepageLocale.de_ch,
        "EN-GB": homepageLocale.en_uk,
        "PL-PL": homepageLocale.pl_pl
    } satisfies Partial<Record<string, homepageLocale>>;
    return apiLocaleMap[locale as keyof typeof apiLocaleMap];
};

export const useNewsletter = (props: { locale: Locale; type: string }) => {
    const [loading, setLoading] = useState(false);

    const subscribe = (input: { name: string; email: string }) => {
        setLoading(true);
        makeGraphqlRequest({
            query: `
            mutation submitNewsletter($input: NewsletterSubscriptionInput!) {
                homepage {
                    subscribeToNewsletter(input: $input)
                }
            }
            `,
            variables: {
                input: {
                    ...input,
                    locale: mapApiLocale(props.locale) ?? homepageLocale.en_uk,
                    type: props.type,
                },
            },
            operationName: "submitNewsletter",
        })
            .then((response) => response.json())
            .then((response) => {})
            .catch((err) => console.error(err))
            .finally(() => setLoading(false));
    };
    return { subscribe, loading };
};
